exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.maintenance_excluded {\n    color: grey;\n}\n", ""]);

// exports
